export const hardwareTypes: { label: string; value: string }[] = [
  { label: "HCV_4G_L", value: "HCV_4G_L" },
  { label: "LCV_4G", value: "LCV_4G" },
  { label: "Pro_4G", value: "Pro_4G" },
  { label: "HCV_4G", value: "HCV_4G" },
  { label: "Eco_4G", value: "Eco_4G" },
  { label: "Smart5", value: "Smart5" },
  { label: "Plug_4G", value: "Plug_4G" },
  { label: "OCV_4G", value: "OCV_4G" },
  { label: "T_4G", value: "T_4G" },
  { label: "AT_4G", value: "AT_4G" },
  { label: "AT_4G_II", value: "AT_4G_II" },
  { label: "OBD_4G", value: "OBD_4G" },
  { label: "ATS_4G", value: "ATS_4G" },
  { label: "ATX_4G", value: "ATX_4G" },
  { label: "IoT_Sigfox", value: "IoT_Sigfox" },
  { label: "IoT_LoRa", value: "IoT_LoRa" },
  { label: "API", value: "API" },
  { label: "LCV_3G", value: "LCV_3G" },
  { label: "Pro_3G", value: "Pro_3G" },
  { label: "HCV_3G", value: "HCV_3G" },
  { label: "Eco_3G", value: "Eco_3G" },
];

// Hardware types served by the Queclink path in the API. A Lua script is a
// Ruptela artifact pushed over the |FU_*_LUA<n>* commands; the Queclink path does
// something entirely different (writes the blob to disk and sends the device a
// URL), so flotilla_api refuses the combination outright in api/admin.go. The UI
// filters it out rather than let an admin build an artifact that only fails later
// at the device-push stage.
//
// NOTE: on the API side this set comes from the `queclink` map in the deployment
// config, not from code - so this list is a copy and can drift from it. Keep them
// in step when a hardware type is added there.
export const queclinkHardwareTypes: string[] = [
  "T_4G",
  "AT_4G",
  "AT_4G_II",
  "ATX_4G",
  "OCV_4G",
  "OBD_4G",
];

export const simTypes: { label: string; value: string }[] = [
  { label: "None", value: "None" },
  { label: "Local", value: "Local" },
  { label: "Global", value: "Global" },
];
